<template>
    <el-card shadow="hover">
        <label slot="header">范围输入 {{`${startlink} - ${endlink}`}}</label>
        <el-divider content-position="left">:start.sync="startlink" :end.sync="endlink"</el-divider>
        <j-link-input :start.sync="startlink" :end.sync="endlink"/>
        <el-divider content-position="left">限定数字 type="number" placeholderStrat="初始数字" placeholderEnd="结束数字" clearable</el-divider>
        <j-link-input :start.sync="startlink" :end.sync="endlink" type="number" placeholderStrat="初始数字" placeholderEnd="结束数字" clearable/>
        <el-divider content-position="left">带单位 unit="单位" range-separator="至" </el-divider>
        <j-link-input :start.sync="startlink" :end.sync="endlink" unit="单位" range-separator="至"/>
        <el-divider content-position="left">v-model (绑定单个字段以,分割)</el-divider>
        <j-link-input v-model="linkStr"/>
    </el-card>
</template>

<script>
    import JLinkInput from "./JLinkInput";
    export default {
        components: {
            JLinkInput
        },
        data() {
            return {
                startlink: '',
                linkStr: '111,334',
                endlink: ''
            }
        },
        created() {

        },
        methods: {}
    }
</script>

<style scoped>

</style>
